module.exports = __webpack_public_path__ + "static/media/header.2def001a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CallTools/Mobile/header.svg
// module id = ./src/assets/CallTools/Mobile/header.svg
// module chunks = 0